<script>
import { mapState } from 'vuex'
import store from '@state/store'

export default {
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapState({
      showing: (state) => state.snackbar.showing,
      color: (state) => state.snackbar.color,
      text: (state) => state.snackbar.text,
    }),
    showingComputed() {
      return this.showing
    },
    colorComputed() {
      return this.color
    },
    textComputed() {
      return this.text
    },
  },
  watch: {
    showing() {
      this.show = this.showing
    },
    show() {
      if (!this.show) {
        store.dispatch('snackbar/resetSnackbar')
      }
    },
  },
}
</script>

<template>
  <v-snackbar
    v-model="show"
    :color="colorComputed"
    timeout="1000"
    class="mb-8"
    content-class="idoor_snackbar"
  >
    {{ textComputed }}
  </v-snackbar>
</template>

<style lang="scss">
.idoor_snackbar {
  color: black !important;
  text-align: center !important;
}
</style>
